/**
 * Strings UI centralizadas (es-CL). Mantener claves estables; el archivo se
 * traduce en bloque si se introduce i18n real.
 */
export const t = {
  app: {
    title: 'ZEngine Admin',
    loading: 'Cargando…',
    error: 'Ocurrió un error',
    retry: 'Reintentar',
    save: 'Guardar',
    cancel: 'Cancelar',
    logout: 'Cerrar sesión',
  },
  nav: {
    dashboard: 'Dashboard',
    tenants: 'Tenants',
    flows: 'Flujos',
    widget: 'Widget',
    channels: 'Channels',
    connectors: 'Connectors',
    templates: 'Templates',
    campaigns: 'Campañas',
    surveys: 'Encuestas',
    widgets: 'Widgets',
    users: 'Usuarios',
  },
  login: {
    redirecting: 'Redirigiendo al inicio de sesión…',
    failed: 'Inicio de sesión fallido',
  },
  callback: {
    processing: 'Procesando autenticación…',
    missingTokens: 'No se recibieron tokens válidos',
    retry: 'Reintentar inicio de sesión',
    retrying: 'La sesión se perdió. Reiniciando login…',
  },
  tenant: {
    listTitle: 'Tenants',
    detailTitle: 'Detalle de tenant',
    newTitle: 'Crear tenant',
    empty: 'No hay tenants disponibles',
    slug: 'Slug',
    slugHelper: 'Identificador URL: minúsculas, números y guion. Ej: acme-corp.',
    name: 'Nombre',
    tier: 'Tier',
    tierHelper: 'Aislamiento de datos: lógico (compartido) o físico (dedicado).',
    tierLabels: {
      logical: 'Logical',
      physical: 'Physical',
      enterprise: 'Enterprise',
    },
    tierDesc: {
      logical: 'Compartido en infra multi-tenant. Costo bajo. Default.',
      physical: 'Recursos dedicados (DDB/Postgres) por tenant. Aislamiento fuerte.',
      enterprise: 'Plan dedicado con organización propia, SLA y soporte premium.',
    },
    enterpriseSoon: 'Próximamente',
    enterpriseDisabled:
      'Tier Enterprise aún no está disponible. Será habilitado cuando esté lista la organización dedicada.',
    locale: 'Idioma',
    featureFlags: 'Feature flags',
    create: 'Crear',
    created: 'Tenant creado',
    newBtn: '+ Nuevo tenant',
    slugConflict: 'Ya existe un tenant con ese slug.',
    editTitle: 'Editar tenant',
    editBtn: 'Editar',
    workspaceUrl: 'URL del workspace',
    workspaceUrlHelp: 'URL pública del tenant para que el cliente acceda al portal customer.',
    copyUrl: 'Copiar URL',
    copied: 'Copiado!',
    open: 'Abrir',
    updated: 'Tenant actualizado',
    versionConflict: 'El tenant cambió en otra sesión. Recargá la página.',
    nameRequired: 'El nombre es obligatorio.',
    slugReadonly: 'El slug no se puede modificar después de creado.',
    noChanges: 'Sin cambios para guardar.',
    flagsHelper: 'Toggle on/off. Key: minúsculas, números, guion/underscore.',
    flagsEmpty: 'No hay feature flags configurados.',
    flagKeyPlaceholder: 'nombre-del-flag',
    flagKeyInvalid: 'Key inválida. Sólo a-z, 0-9, - y _ (debe empezar con letra/número).',
    addFlag: '+ Agregar',
  },
  contact: {
    title: 'Contactos',
    empty: 'No hay contactos. Creá el primero para comenzar.',
    newBtn: 'Nuevo contacto',
    created: 'Contacto creado correctamente.',
    updated: 'Contacto actualizado',
    archived: 'Contacto archivado',
    search: 'Buscar por nombre, teléfono o email…',
    consentLabel: 'Notificaciones',
    consentAll: 'Todos',
    consentAccepted: 'Aceptados',
    consentRejected: 'Rechazados',
    consentUnknown: 'Sin definir',
    statusLabel: 'Estado',
    statusAll: 'Todos',
    statusActive: 'Activos',
    statusBlocked: 'Bloqueados',
    statusArchived: 'Archivados',
    cols: {
      name: 'Nombre',
      phone: 'Teléfono',
      email: 'Email',
      channel: 'Canal',
      consent: 'Notif.',
      status: 'Estado',
      lastContact: 'Último contacto',
      actions: 'Acciones',
    },
    form: {
      name: 'Nombre',
      phone: 'Teléfono',
      email: 'Email',
      preferredChannel: 'Canal preferido',
      consent: 'Consentimiento notificaciones',
      tags: 'Tags (separados por coma)',
      submit: 'Crear contacto',
      save: 'Guardar cambios',
      cancel: 'Cancelar',
      edit: 'Editar contacto',
    },
    conflict: 'Ya existe un contacto con ese teléfono.',
    editBtn: 'Editar',
    archiveBtn: 'Archivar',
    confirmArchive: '¿Archivar este contacto? Quedará oculto del listado pero conservado en histórico.',
  },
  flow: {
    listTitle: 'Flujos',
    editorTitle: 'Editor de flujo',
    invalidJson: 'JSON inválido',
    schemaError: 'El flujo no cumple el schema',
    publish: 'Publicar',
    channel: 'Canal',
    refresh: 'Recargar',
    edit: 'Editar flujo',
    create: 'Crear flujo',
    notDeployed: 'Sin flujo desplegado',
    fallbackNote:
      'Los canales sin flujo desplegado aparecen atenuados. Click en "Crear" para empezar uno desde un template básico.',
    tabVisual: 'Visual',
    tabJson: 'JSON',
    visualNeedsData:
      'Cargando flujo… El editor visual aparece cuando el flujo tiene un array steps válido.',
    intro:
      'Cada tipo de canal habilitado puede tener un flujo conversacional propio. Agregá canales en la sección Channels para que aparezcan acá.',
    noChannelsTitle: 'Este tenant aún no tiene canales habilitados.',
    noChannelsDesc:
      'Los flujos se asocian a tipos de canal (WhatsApp, Webchat, etc.). Configurá al menos un canal para empezar a definir flujos.',
    goToChannels: 'Ir a Channels',
  },
  widget: {
    previewTitle: 'Vista previa del widget',
    primaryColor: 'Color primario',
    accentColor: 'Color secundario',
    radius: 'Radio',
    listTitle: 'Widgets',
    newTitle: 'Nuevo widget',
    editTitle: 'Editar widget',
    empty: 'No hay widgets configurados',
    newBtn: '+ Nuevo widget',
    showArchived: 'Mostrar archivados',
    archive: 'Archivar',
    edit: 'Editar',
    setDefault: 'Marcar default',
    isDefault: 'Default',
    confirmArchiveTitle: '¿Archivar este widget?',
    confirmArchiveDesc:
      'El widget quedará oculto. Si era default, marcá otro como default antes.',
    archived: 'Widget archivado',
    created: 'Widget creado',
    updated: 'Widget actualizado',
    setDefaultSuccess: 'Widget marcado como default',
    versionConflict:
      'El widget cambió en otra sesión. Recargá la página para ver la última versión.',
    sectionColors: 'Colores',
    sectionStyle: 'Estilo',
    sectionTexts: 'Textos',
    sectionImages: 'Imágenes opcionales',
    previewClosed: 'Launcher cerrado',
    previewOpen: 'Chat abierto',
    fields: {
      name: 'Nombre',
      isDefault: 'Default',
      updated: 'Actualizado',
      version: 'Versión',
      actions: 'Acciones',
      primaryColor: 'Color primario',
      headerColor: 'Color del header',
      backgroundColor: 'Fondo',
      userBubbleColor: 'Burbuja usuario',
      agentBubbleColor: 'Burbuja agente',
      textColor: 'Texto',
      mutedColor: 'Texto secundario',
      fontFamily: 'Tipografía',
      design: 'Diseño',
      borderRadius: 'Border radius',
      bodyPattern: 'Patrón de fondo',
      launcherPosition: 'Posición launcher',
      title: 'Título',
      subtitle: 'Subtítulo',
      profileImageUrl: 'Imagen de perfil (URL o data:)',
      launcherIconUrl: 'Icono launcher (URL o data:)',
    },
    design: {
      rounded: 'Redondeado',
      square: 'Cuadrado',
      minimal: 'Minimal',
    },
    bodyPattern: {
      dots: 'Puntos',
      lines: 'Líneas',
      solid: 'Sólido',
      none: 'Ninguno',
    },
    launcher: {
      left: 'Izquierda',
      right: 'Derecha',
    },
    nameRequired: 'El nombre es obligatorio.',
    nameTooLong: 'Máximo 120 caracteres.',
    colorInvalid: 'Color hex inválido. Formato #RRGGBB.',
    titleTooLong: 'Máximo 40 caracteres.',
    subtitleTooLong: 'Máximo 80 caracteres.',
    fontFamilyRequired: 'La tipografía es obligatoria.',
  },
  survey: {
    listTitle: 'Encuestas',
    newTitle: 'Nueva encuesta',
    editTitle: 'Editar encuesta',
    empty: 'No hay encuestas configuradas',
    newBtn: '+ Nueva encuesta',
    showArchived: 'Mostrar archivadas',
    filterStatus: 'Filtrar por estado',
    filterAll: 'Todos los estados',
    archive: 'Archivar',
    edit: 'Editar',
    confirmArchiveTitle: '¿Archivar esta encuesta?',
    confirmArchiveDesc: 'La encuesta quedará oculta pero auditable.',
    archived: 'Encuesta archivada',
    created: 'Encuesta creada',
    updated: 'Encuesta actualizada',
    versionConflict:
      'La encuesta cambió en otra sesión. Recargá la página para ver la última versión.',
    fields: {
      name: 'Nombre',
      description: 'Descripción',
      flowId: 'Flow ID',
      channel: 'Canal',
      status: 'Estado',
      questionsCount: 'Preguntas',
      responsesCount: 'Respuestas',
      averageScore: 'Score promedio',
      startsAt: 'Inicio',
      endsAt: 'Fin',
      version: 'Versión',
      actions: 'Acciones',
    },
    status: {
      active: 'Activa',
      paused: 'Pausada',
      archived: 'Archivada',
    },
    nameRequired: 'El nombre es obligatorio.',
    nameTooLong: 'Máximo 120 caracteres.',
    descriptionTooLong: 'Máximo 500 caracteres.',
    flowIdRequired: 'El Flow ID es obligatorio.',
    flowIdInvalid:
      'Sólo minúsculas, números y guion (regex /^[a-z0-9-]+$/).',
    averageScoreRange: 'Score debe estar entre 0 y 10.',
    flowIdHelper: 'Minúsculas, números y guion. Ej: nps-onboarding-v1.',
    channelOptional: 'Sin canal',
  },
  channel: {
    listTitle: 'Channels',
    newTitle: 'Nuevo channel',
    editTitle: 'Editar channel',
    empty: 'No hay channels configurados',
    newBtn: '+ Nuevo channel',
    showArchived: 'Mostrar archivados',
    archive: 'Archivar',
    edit: 'Editar',
    confirmArchiveTitle: '¿Archivar este channel?',
    confirmArchiveDesc:
      'Channel quedará oculto pero auditable. Acción reversible vía API si fuera necesario.',
    archived: 'Channel archivado',
    created: 'Channel creado',
    updated: 'Channel actualizado',
    versionConflict:
      'El channel cambió en otra sesión. Recargá la página para ver la última versión.',
    fields: {
      name: 'Nombre',
      channelType: 'Tipo',
      phoneId: 'Phone ID',
      displayPhoneNumber: 'Número visible',
      verifiedName: 'Nombre verificado',
      domain: 'Dominio',
      status: 'Estado',
      tokenSecretArn: 'Token Secret ARN',
      version: 'Versión',
      actions: 'Acciones',
    },
    status: {
      connected: 'Conectado',
      disconnected: 'Desconectado',
      error: 'Error',
    },
    arnHelper:
      'Crea el secret en Secrets Manager primero y pegá el ARN aquí.',
    arnExample:
      'Ej: arn:aws:secretsmanager:us-east-2:450972188274:secret:zen-dev/whatsapp/iplacex-AbCdEf',
    arnInvalid: 'ARN inválido. Debe coincidir con el formato Secrets Manager.',
    nameRequired: 'El nombre es obligatorio.',
    nameTooLong: 'Máximo 120 caracteres.',
    typeRequired: 'Seleccioná un tipo.',
    five9Title: 'Configuración Five9 Digital',
    five9Desc:
      'Crea un secret en AWS Secrets Manager con este shape y pegá el ARN abajo. El connector-cc lo lee cuando un flujo ejecuta handoff target=five9-digital.',
    five9HandoffHint:
      'En el flujo, agregá un step type=handoff con target=five9-digital para enrutar la conversación a Five9.',
  },
  connector: {
    listTitle: 'Outbound Connectors',
    newTitle: 'Nuevo connector',
    editTitle: 'Editar connector',
    empty: 'No hay connectors configurados',
    newBtn: '+ Nuevo connector',
    showArchived: 'Mostrar archivados',
    archive: 'Archivar',
    edit: 'Editar',
    confirmArchiveTitle: '¿Archivar este connector?',
    confirmArchiveDesc:
      'El connector quedará oculto. Los templates asociados seguirán visibles pero no podrán enviar mensajes.',
    archived: 'Connector archivado',
    created: 'Connector creado',
    updated: 'Connector actualizado',
    versionConflict:
      'El connector cambió en otra sesión. Recargá la página para ver la última versión.',
    fields: {
      name: 'Nombre',
      provider: 'Proveedor',
      businessPhone: 'Teléfono comercial',
      wabaId: 'WABA ID',
      phoneNumberId: 'Phone Number ID',
      displayPhoneNumber: 'Número visible',
      verifiedName: 'Nombre verificado',
      apiKeySecretArn: 'API Key Secret ARN',
      status: 'Estado',
      version: 'Versión',
      actions: 'Acciones',
    },
    status: {
      connected: 'Conectado',
      error: 'Error',
    },
    arnHelper: 'Crea el secret en Secrets Manager primero y pegá el ARN aquí.',
    arnExample:
      'Ej: arn:aws:secretsmanager:us-east-2:450972188274:secret:zen-dev/wa/iplacex-AbCdEf',
    arnInvalid: 'ARN inválido. Debe coincidir con el formato Secrets Manager.',
    nameRequired: 'El nombre es obligatorio.',
    nameTooLong: 'Máximo 120 caracteres.',
    providerRequired: 'Seleccioná un proveedor.',
  },
  template: {
    listTitle: 'Outbound Templates',
    newTitle: 'Nuevo template',
    editTitle: 'Editar template',
    empty: 'No hay templates configurados',
    newBtn: '+ Nuevo template',
    showArchived: 'Mostrar archivados',
    filterConnector: 'Filtrar por connector',
    filterAll: 'Todos los connectors',
    archive: 'Archivar',
    edit: 'Editar',
    confirmArchiveTitle: '¿Archivar este template?',
    confirmArchiveDesc:
      'El template quedará oculto pero auditable.',
    archived: 'Template archivado',
    created: 'Template creado',
    updated: 'Template actualizado',
    versionConflict:
      'El template cambió en otra sesión. Recargá la página para ver la última versión.',
    invalidConnector:
      'El connector seleccionado no existe o pertenece a otro tenant.',
    fields: {
      name: 'Nombre',
      templateName: 'Template name (provider)',
      connector: 'Connector',
      language: 'Idioma',
      category: 'Categoría',
      templateType: 'Tipo',
      status: 'Estado',
      bodyText: 'Cuerpo',
      placeholders: 'Placeholders',
      components: 'Components (JSON)',
      providerTemplateId: 'Provider template ID',
      externalId: 'External ID',
      namespace: 'Namespace',
      version: 'Versión',
      actions: 'Acciones',
      advanced: 'Avanzado',
    },
    status: {
      approved: 'Aprobado',
      pending: 'Pendiente',
      rejected: 'Rechazado',
      draft: 'Borrador',
    },
    nameRequired: 'El nombre es obligatorio.',
    nameTooLong: 'Máximo 120 caracteres.',
    templateNameRequired: 'El template name es obligatorio.',
    templateNameInvalid:
      'Sólo minúsculas, números y guion bajo (regex /^[a-z0-9_]+$/).',
    bodyRequired: 'El cuerpo es obligatorio.',
    bodyTooLong: 'Máximo 1024 caracteres.',
    languageInvalid: 'Formato inválido. Ej: es, es-CL, en, en-US.',
    connectorRequired: 'Seleccioná un connector.',
    placeholdersMax: 'Máximo 20 placeholders.',
    componentsInvalidJson: 'Components no es JSON válido.',
    componentsMustBeArray: 'Components debe ser un array.',
    addPlaceholder: 'Agregar placeholder…',
    placeholdersHelper: 'Presioná Enter para agregar. Click en × para quitar.',
    bodyHelper: 'Hasta 1024 caracteres.',
    componentsHelper: 'JSON libre (Meta WABA). Opcional.',
  },
  campaign: {
    listTitle: 'Campañas',
    newTitle: 'Nueva campaña',
    editTitle: 'Editar campaña',
    detailTitle: 'Detalle de campaña',
    empty: 'No hay campañas configuradas',
    newBtn: '+ Nueva campaña',
    showArchived: 'Mostrar archivadas',
    filterStatus: 'Filtrar por estado',
    filterAll: 'Todos los estados',
    archive: 'Archivar',
    edit: 'Editar',
    detail: 'Detalle',
    confirmArchiveTitle: '¿Archivar esta campaña?',
    confirmArchiveDesc:
      'La campaña quedará oculta pero auditable. No se podrá ejecutar más.',
    archived: 'Campaña archivada',
    created: 'Campaña creada',
    updated: 'Campaña actualizada',
    executed: 'Campaña enviada a ejecución',
    versionConflict:
      'La campaña cambió en otra sesión. Recargá la página para ver la última versión.',
    invalidConnector:
      'El connector seleccionado no existe o pertenece a otro tenant.',
    invalidTemplate:
      'El template seleccionado no existe o pertenece a otro tenant.',
    templateConnectorMismatch:
      'El template no pertenece al connector seleccionado.',
    fields: {
      name: 'Nombre',
      description: 'Descripción',
      connector: 'Connector',
      template: 'Template',
      status: 'Estado',
      scheduledAt: 'Programado para',
      contactsCount: 'Contactos',
      deliveredCount: 'Entregados',
      failedCount: 'Fallidos',
      rateLimitPerSecond: 'Rate limit (msg/s)',
      variableMap: 'Mapeo de variables',
      version: 'Versión',
      actions: 'Acciones',
      csv: 'Contactos CSV',
      createdAt: 'Creada',
    },
    status: {
      draft: 'Borrador',
      scheduled: 'Programada',
      running: 'Ejecutando',
      completed: 'Completada',
      archived: 'Archivada',
    },
    sections: {
      basic: 'Datos básicos',
      schedule: 'Programación',
      metrics: 'Métricas',
      csv: 'Contactos CSV',
      execute: 'Ejecutar',
    },
    nameRequired: 'El nombre es obligatorio.',
    nameTooLong: 'Máximo 120 caracteres.',
    descriptionTooLong: 'Máximo 500 caracteres.',
    connectorRequired: 'Seleccioná un connector.',
    templateRequired: 'Seleccioná un template.',
    rateLimitInvalid: 'Rate limit debe estar entre 1 y 100.',
    uploadCsv: 'Subir CSV',
    replaceCsv: 'Reemplazar CSV',
    pickCsv: 'Seleccionar archivo CSV',
    csvUploading: 'Subiendo CSV…',
    csvUploaded: 'CSV subido',
    csvLargeWarning:
      'Archivo grande (>10 MB): se subirá sin contar filas en cliente.',
    csvNotPresent: 'Sin CSV cargado.',
    executeNow: 'Ejecutar ahora',
    schedule: 'Programar',
    executeRequiresCsv: 'Subí un CSV antes de ejecutar.',
    notFound: 'Campaña no encontrada',
    addVariable: 'Agregar variable',
    variableKey: 'Variable',
    variableValue: 'Columna CSV / valor',
    countdownIn: 'En',
    countdownPast: 'Programación pasada',
    rateLimitHelper: 'Opcional. 1..100 mensajes por segundo.',
    descriptionHelper: 'Opcional. Hasta 500 caracteres.',
  },
  user: {
    listTitle: 'Usuarios del tenant',
    newTitle: 'Nuevo usuario',
    editTitle: 'Editar usuario',
    newBtn: '+ Nuevo usuario',
    empty: 'No hay usuarios en este tenant.',
    create: 'Crear',
    created: 'Usuario creado. Email de invitación enviado.',
    updated: 'Usuario actualizado.',
    deleted: 'Usuario eliminado.',
    passwordReset: 'Password reset disparado. El usuario recibirá un email.',
    edit: 'Editar',
    delete: 'Eliminar',
    resetPassword: 'Reset password',
    confirmDeleteTitle: '¿Eliminar usuario?',
    confirmDeleteDesc:
      'Se eliminará permanentemente la cuenta {{email}} de Cognito. Esta acción no se puede deshacer.',
    fields: {
      email: 'Email',
      displayName: 'Nombre',
      roles: 'Roles',
      status: 'Estado',
      actions: 'Acciones',
    },
    rolesHelper: 'admin: gestiona usuarios y todo. editor: edita recursos. agent: opera chats. viewer: solo lectura.',
    emailRequired: 'El email es obligatorio.',
    emailReadonly: 'El email no se puede cambiar después de creado el usuario.',
    emailConflict: 'Ya existe un usuario con ese email.',
    rolesRequired: 'Asigná al menos un rol.',
    rootUser: 'Usuario raíz',
    noRootUser: 'Sin usuario raíz asignado.',
    rootHelper:
      'El usuario raíz es el administrador inicial del tenant. Sólo se puede gestionar desde la administración global de tenants.',
    manageUsers: 'Gestionar usuarios',
  },
  topbar: {
    activeTenant: 'Tenant activo',
    selectTenant: 'Seleccionar tenant…',
  },
} as const;
